import { useQueryClient } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { toast } from "sonner";
import { useRouter } from "@/i18n/navigation";
import { $api } from "@/lib/api-client";

export const useFeedbackForm = (onSuccess?: () => void) => {
  const t = useTranslations("feedback");
  const queryClient = useQueryClient();
  const router = useRouter();

  return $api.useMutation("post", "/feedback", {
    onSuccess: () => {
      toast.success(t("toasts.success"), {
        description: t("toasts.successDescription"),
        duration: Number.POSITIVE_INFINITY,
        action: {
          label: t("toasts.viewMyFeedback"),
          onClick: () => router.push("/profile/feedback"),
        },
      });
      queryClient.invalidateQueries({ queryKey: ["get", "/feedback/me"] });
      onSuccess?.();
    },
    onError: (error: unknown) => {
      const err = error as { statusCode?: number } | undefined;
      if (err?.statusCode === 429) {
        toast.warning(t("toasts.rateLimit"));
      } else {
        toast.error(t("toasts.error"));
      }
    },
  });
};
